import actiontypes from "../actions/actiontypes";
import {handleError, setTranslatableErrorMessage} from "../actions/loginactioncreators";
import {call, put, takeLatest} from "redux-saga/effects"
import CognitoPasswordValidator from "../../components/changePasswordForm/CognitoPasswordValidator"; // todo: switch this ref to shared version
import { defineMessage } from "react-intl";

let cognitoPasswordValidator = new CognitoPasswordValidator(8, 99, true, true, true, true);

export function* validatePasswordAsync(action) {
  try {
    let errors = yield call(validatePassword, action.payload);
    yield put(setTranslatableErrorMessage(errors));
  } catch (error) {
    yield put(handleError(error));
  }
}

export function validatePassword(password) {
  const errors = cognitoPasswordValidator.validatePasswordFormat(password);
  if (errors.length > 0) {
    errors.push({message: defineMessage({
        id: "password.requirements",
        defaultMessage: "Due to recent changes, your existing password may not match the requirements. Please Reset Password to change your password",
        description: "Error message for password field"
    })});
  }
  return errors;
}

export function* watchValidatePasswordAsync() {
  yield takeLatest(actiontypes.SET_PASSWORD_VALIDATION, validatePasswordAsync);
}